<!--
Description
This components adds selections boxes to a form with:
 - establishments
 - positions
 - (TODO) groups

 It loads all establisments and all posiitions and displays them in lists of checkboxes.

 When (de)selecting a checkbox an event is emitted to the parent component sending an array of all selected options.

How to use
put <Selectoptions v-on:setOptions="setOptions"></Selectoptions> where you need it (in or outside a form)
@event setOptions: triggered when a checkbox is clicked.
@emit data: object containing an array per list with the id's (String) of the selected options. Empty when all is selected.

In the parent component create a method setOptions(data) (or whatever name you want) recieving this data object:

data: {
  checkedPositions: [],
  checkedEstablishments: []
}

-->

<template>
    <div id="selectoptions">
        
      <div class="form-group mt-3">
        <h3>Toegankelijkheid beperken</h3>
      </div>
      <div class="row">
        <div class="col">
          <h4>Vestigingen</h4>
          <input
            type="checkbox"
            value="all"
            @click="toggleAllEstablishments"
            checked
            v-model="checkedAllEstablishments"
          />
          <label>Alle vestigingen</label>
          <div v-for="est in establishments" :key="est.id">
            <input
              :value="est.id"
              type="checkbox"
              :id="est.id"
              v-model="checkedEstablishments"
              @click="deselectAllEstablishments"
              @change="emit"
               class="form-check-input" 
            />
            <label class="form-check-label">{{est.name}}</label>
          </div>
        </div>
        <div class="col">
          <h4>Functies</h4>
          <input
            type="checkbox"
            value="all"
            @click="toggleAllPositions"
            checked
            v-model="checkedAllPositions"
          />
          <label>Alle functies</label>
          <div v-for="pos in positions" :key="pos.id">
            <input
              :value="pos.id"
              type="checkbox"
              :id="pos.id"
              v-model="checkedPositions"
              @click="deselectAllPositions"
              @change="emit"
               class="form-check-input" 
            />
            <label class="form-check-label" >{{pos.name}}</label>
          </div>
          
          <button @click="addPosition">voeg een functie toe</button>
          </div>
        <!-- <div class="col">Groepen TODO</div> -->
    </div>
    </div>
</template>




<script>
const fb = require("@/firebaseConfig.js");
export default {    
      name: "Selectoptions",
      props:
        ['checkedPositions', 'checkedEstablishments'],
  data() {
    return {
      establishments: [],
      positions: [],
      //checkedEstablishments: [],
      checkedAllEstablishments: true,
     // checkedPositions: [],
      checkedAllPositions: true
    };
  },
  methods: {
    emit(){      
      this.$emit('setOptions', {checkedPositions: this.checkedPositions,checkedEstablishments: this.checkedEstablishments})
    },
    toggleAllEstablishments() {
      this.checkedAllEstablishments = !this.checkedAllEstablishments;
      if (this.checkedEstablishments) {
        this.checkedEstablishments = [];
      }
      this.$emit('setOptions', {checkedPositions: this.checkedPositions,checkedEstablishments: this.checkedEstablishments})
    },
    deselectAllEstablishments() {
      this.checkedAllEstablishments = false;
    },
    toggleAllPositions() {
      this.checkedAllPositions = !this.checkedAllPositions;
      if (this.checkedPositions) {
        this.checkedPositions = [];
      }
      this.$emit('setOptions', {checkedPositions: this.checkedPositions,checkedEstablishments: this.checkedEstablishments})
    },
    deselectAllPositions() {
      this.checkedAllPositions = false;
    },
    addPosition(){
      var newname = prompt("Type de naam van de functie die je wilt toevoegen:")
      if (!newname) return false;
      var t = this
      var newPosition = {
        color: "D32F2F", // TODO
        name: newname
      }
      fb.companiesCollection
      .doc(this.$cookies.get("company"))
      .collection('positions')
      .add(newPosition).then(function(docRef){
        newPosition.id = docRef.id
        t.positions.push(newPosition)
      })
    }
  },
  beforeCreate() {
    fb.companiesCollection
      .doc(this.$cookies.get("company"))
      .collection("establishments")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            id: doc.id,
            address: doc.data().address,
            city: doc.data().city,
            phonenumber: doc.data().phonenumber,
            zipcode: doc.data().zipcode,
            name: doc.data().name
          };
          this.establishments.push(data);
        });
      });

    fb.companiesCollection
      .doc(this.$cookies.get("company"))
      .collection("positions")
      .orderBy("name")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            id: doc.id,
            color: doc.data().color,
            name: doc.data().name
          };
          this.positions.push(data);
        });
      });
  }

}
</script>